import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";


const HelpSection = () => {

const navigate=useNavigate()
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      className="mt-12 bg-gradient-to-r from-gray-700 to-slate-800 rounded-3xl p-8 text-white shadow-xl"
    >
      <div className="text-center">
        <h3 className="text-2xl font-bold mb-4">Need Help?</h3>
        <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
          Sender IDs help recipients identify your messages. Choose names that
          represent your brand or business for better recognition and trust.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={()=>navigate("/contact-us")} className="px-6 py-3 bg-white text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition-colors duration-200 shadow-md">
            Contact Support
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default HelpSection; 